import { Tooltip, Typography } from "@compass/core";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DateRangeIcon from "@mui/icons-material/DateRange";
import NumbersIcon from "@mui/icons-material/Numbers";
import TitleIcon from "@mui/icons-material/Title";
import { ReportPropertyBase, ReportPropertySubType, ReportPropertyType } from "generated/openApi";
import DoneIcon from "@mui/icons-material/Done";
import DownloadDoneIcon from "@mui/icons-material/DownloadDone";
import ListIcon from "@mui/icons-material/List";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";

export const ReportPropertyIcon = (props: { property: ReportPropertyBase }) => {
  const fontSize = "1rem";
  const opacity = "0.7";
  let icon: React.ReactElement | undefined = undefined;
  let desc: string | undefined = undefined;

  const propertyType = props.property.propertyType;
  const propertySubType = props.property.propertySubType;

  switch (propertyType) {
    case ReportPropertyType.String:
      icon = <TitleIcon sx={{ fontSize: fontSize, opacity: opacity }} />;
      desc = "Text";
      break;
    case ReportPropertyType.Int:
      if (propertySubType === ReportPropertySubType.DurationInMinutes) {
        icon = <HourglassBottomIcon sx={{ fontSize: fontSize, opacity: opacity }} />;
        desc = "Duration";
        break;
      }

      icon = <NumbersIcon sx={{ fontSize: fontSize, opacity: opacity }} />;
      desc = "Number";
      break;
    case ReportPropertyType.Decimal:
      icon = <NumbersIcon sx={{ fontSize: fontSize, opacity: opacity }} />;
      desc = "Number";
      break;
    case ReportPropertyType.Date:
      icon = <CalendarTodayIcon sx={{ fontSize: fontSize, opacity: opacity }} />;
      desc = "Date";
      break;
    case ReportPropertyType.DateTimeOffset:
      icon = <DateRangeIcon sx={{ fontSize: fontSize, opacity: opacity }} />;
      desc = "Datetime";
      break;
    case ReportPropertyType.Bool:
      icon = <DoneIcon sx={{ fontSize: fontSize, opacity: opacity }} />;
      desc = "Yes/No";
      break;
    case ReportPropertyType.NullableBool:
      icon = <DownloadDoneIcon sx={{ fontSize: fontSize, opacity: opacity }} />;
      desc = "Yes/No/Blank";
      break;
    case ReportPropertyType.TimeSpan:
      icon = <AccessTimeIcon sx={{ fontSize: fontSize, opacity: opacity }} />;
      desc = "Time";
      break;
  }

  if (props.property.selectList) {
    icon = <ListIcon sx={{ fontSize: fontSize, opacity: opacity }} />;
    desc = "Select options";
  }

  if (icon) return <Tooltip title={desc}>{icon}</Tooltip>;
  return null;
};
